import { GUID } from "@faro-lotv/foundation";
import { create } from "zustand";

type ScansExportStore = {
  /** The list of scans/rooms selected by the user */
  selectedIds: GUID[];
  /** A callback to select exactly one scan */
  selectId(selectedId: GUID): void;
  /** A callback to select multiple scans/rooms at the same time */
  multiSelectIds(selectedIds: GUID[]): void;
  /** A callback to toggle the selection state of a scans/rooms */
  toggleSelectedId(selectedId: GUID): void;
  /** A callback to clear the list of selected elements */
  clearSelection(): void;
  /** The list of scans/rooms hovered by the user */
  hoveredIds: GUID[];
  /** A callback to hover exactly one scan  */
  hoverId(hoveredId: GUID): void;
  /** A callback to hover multiple scans/rooms at the same time */
  multiHoverIds(hoveredIds: GUID[]): void;
  /* A callback to clear the list of hovered elements */
  clearHovering(): void;
};

export const useScansExportStore = create<ScansExportStore>(
  (set, getState) => ({
    selectedIds: [],
    selectId: (selectedId: GUID) => set({ selectedIds: [selectedId] }),
    multiSelectIds: (selectedIds: GUID[]) => set({ selectedIds }),
    toggleSelectedId: (selectedId: GUID) => {
      const state = getState();
      const selectedIndex = state.selectedIds.findIndex(
        (id) => selectedId === id,
      );
      if (selectedIndex >= 0) {
        const newSelectedIds = [...state.selectedIds];
        newSelectedIds.splice(selectedIndex, 1);
        set({ selectedIds: newSelectedIds });
      } else {
        set({ selectedIds: [...state.selectedIds, selectedId] });
      }
    },
    clearSelection: () => set({ selectedIds: [] }),
    hoveredIds: [],
    hoverId: (hoveredId: GUID) => set({ hoveredIds: [hoveredId] }),
    multiHoverIds: (hoveredIds: GUID[]) => set({ hoveredIds }),
    clearHovering: () => set({ hoveredIds: [] }),
  }),
);
